"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RailContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RailContainer = ({
  children,
  ...restProps
}) => {
  return /*#__PURE__*/_react.default.createElement(_styles.RailContainerStyle, restProps, children);
};

exports.RailContainer = RailContainer;
RailContainer.defaultProps = {
  width: '113px',
  height: '100%',
  position: 'right'
};
RailContainer.propTypes = {
  children: _propTypes.default.node,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  position: _propTypes.default.string
};